var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrossPlusIcon = function SvgCrossPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "share-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.585,
    height: 15.585
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.792 0a.842.842 0 0 0-.842.842V6.95H.843a.843.843 0 1 0 0 1.685H6.95v6.108a.843.843 0 0 0 1.685 0V8.635h6.107a.843.843 0 1 0 0-1.685H8.635V.842A.842.842 0 0 0 7.792 0Z",
    fill: "#707070"
  })));
};
export default SvgCrossPlusIcon;